<script>
import formMixin from '../../mixin/formMixin'
import AnsoDescriptions from '../anso-descriptions'
import { isDefined } from '../../utils/utils'
export default {
  name: 'AnsoForm',
  components: { AnsoDescriptions },
  mixins: [formMixin],
  props: {
    // 以下是表单el-form的配置属性
    formRef: {
      require: false,
      type: String,
      default: () => {
        return 'ansoForm'
      },
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    formList: {
      type: Array,
      default: () => [],
    },
    modelType: {
      // 支持三种类型add\edit\detail
      require: false,
      type: String,
      default: () => {
        return 'add'
      },
    },
    labelWidth: {
      required: false,
      type: String,
      default: () => {
        return '80px'
      },
    },
    labelPosition: {
      required: false,
      type: String,
      default: () => {
        return 'right' // 取值范围right、left、top
      },
    },
    rules: {
      required: false,
      type: Object,
      default: () => {
        return {}
      },
    },
    size: {
      required: false,
      type: String,
      default: () => {
        return 'small' // 取值范围medium、small、mini
      },
    },
    // 以下是el-row的配置属性
    gutter: {
      required: false,
      type: Number,
      default: () => {
        return 10
      },
    },
    hideRequiredAsterisk: {
      required: false,
      type: Boolean,
      default: () => {
        return false
      },
    },
    validateOnRuleChange: {
      required: false,
      type: Boolean,
      default: () => true,
    },
    colon: {
      // 是否显示label后面的冒号
      required: false,
      type: Boolean,
      default: () => false,
    },
    // 以下是el-col的配置属性
    // 以下是el-form-item的配置属性

    // 以下是formItem子项的配置属性模板
    /**
     * {
     *   label: 'item名字',
     *   field: 'item字段',
     *   type: 'item类型',
     *   value: 'item值',
     *   props: { // 具体子组件的配置属性如（input、 select、 raido、	  checkbox...）
     *     placeholder: '请输入item名字',
     *     disabled: false, // 是否禁用}
     *
     * }
     */
  },
  created() {
    this.formList.forEach((item) => {
      if (
        item.type === 'title' ||
        item.type === 'divider' ||
        item.type === 'subTitle'
      ) {
        this.$set(item, 'notFormItem', true)
      }
      if (isDefined(item['field'])) {
        // 新增模式下初始化表单字段
        if (this.modelType === 'add') {
          if (
            item.type === 'checkbox' ||
            (item.type === 'select' && item.multiple) ||
            (item.type === 'selectTree' && item.multiple) ||
            item.type === 'dataRange'
          ) {
            this.$set(
              this.form,
              item['field'],
              Array.isArray(item['value']) ? item['value'] : []
            )
          } else if (
            item.type === 'multipleTime' ||
            item.type === 'mixinInput' ||
            (item.type === 'dateCombination' &&
              item.valueType === 'multiple') ||
            item.type === 'descriptions'
          ) {
            this.$set(this.form, item['field'], item['value'] || {})
          } else {
            this.$set(this.form, item['field'], item['value'] ?? '')
          }
        }
      }
    })
    console.log('============新增模式初始化表单字段==============', this.form)
  },
  methods: {
    submitForm(callback) {
      this.$refs[this.formRef].validate((valid) => {
        if (valid) {
          typeof callback == 'function' && callback(valid)
        } else {
          this.$nextTick(() => {
            let parentEl = this.$el.parentElement
            let parentBound = parentEl ? parentEl.getBoundingClientRect() : {}
            let errEls = this.$el.querySelectorAll(
              '.mixin-form .el-form-item .el-form-item__content .el-form-item__error'
            )
            if (errEls?.length) {
              let firstBound = errEls[0].getBoundingClientRect()
              if (firstBound.y < parentBound.y) {
                parentEl.scrollTop = 0
              }
              if (firstBound.y > parentBound.y + parentBound.height) {
                parentEl.scrollTop = firstBound.y - parentBound.y - 100
              }
            }
          })
          typeof callback == 'function' && callback(valid)
          return false
        }
      })
    },
    resetForm() {
      this.$refs[this.formRef]?.resetFields()
    },
    generateForm() {
      return (
        <el-form
          ref={this.formRef}
          size={this.size}
          hide-required-asterisk={this.hideRequiredAsterisk}
          props={{ model: this.form }}
          rules={this.rules}
          label-width={this.labelWidth}
          label-position={this.labelPosition}
          validate-on-rule-change={this.validateOnRuleChange}
          nativeOnSubmit={(e) => e.preventDefault()}
        >
          {this.generateRow()}
        </el-form>
      )
    },
    generateRow() {
      return (
        <el-row gutter={this.gutter}>
          {this.formList.map((item) => this.generateCol(item))}
          {this.$slots?.rowTail}
        </el-row>
      )
    },
    generateCol(item) {
      let { span, notFormItem, isHidden, type } = item
      if (
        (typeof isHidden === 'boolean' && isHidden) ||
        (typeof isHidden === 'function' && isHidden(item, this.form))
      ) {
        return
      }
      if (type === 'title' || type === 'subTitle') {
        notFormItem = true
      }
      return (
        <el-col span={span}>
          {notFormItem
            ? this.generateNotFormItem(item)
            : this.generateFormItem(item)}
        </el-col>
      )
    },
    generateTips(item) {
      let { tips } = item
      if (!tips || (tips && !tips.content)) {
        return
      }
      let { content, placement = 'top', effect = 'light' } = tips
      return (
        <el-tooltip
          props={{
            effect,
            placement,
          }}
        >
          <template slot="content">
            {typeof content === 'function' ? content(item, this.form) : content}
          </template>
          <i
            class="iconfont icon-hint1"
            style={{ 'font-size': '14px', color: '#BFBFBF' }}
          ></i>
        </el-tooltip>
      )
    },
    generateFormItem(item) {
      let { label, field, rules, labelWidth } = item
      return (
        <el-form-item
          label={label}
          prop={field}
          rules={rules}
          label-width={labelWidth || ''}
        >
          <template slot="label">
            <div
              class={[
                'label-title',
                this.hideRequiredAsterisk ? 'hide-required-asterisk' : '',
              ]}
            >
              <span style={{ position: 'relative' }}>
                {label}
                {this.modelType === 'detail' || this.colon ? (
                  <span>:</span>
                ) : (
                  ''
                )}
              </span>
              {this.generateTips(item)}
            </div>
          </template>
          {this.generateFormItemChild(item, this.form)}
        </el-form-item>
      )
    },
    generateNotFormItem(item) {
      return this.generateFormItemChild(item, this.form)
    },
  },
  render() {
    return (
      <div
        class={[
          'form-container',
          this.modelType === 'detail' ? 'form-detail' : '',
        ]}
      >
        {this.generateForm()}
      </div>
    )
  },
}
</script>

<style lang="scss" scoped>
.form-container {
  .el-row {
    display: flex;
    flex-wrap: wrap;
  }
  // 样式穿透写在此处
  ::v-deep .el-form-item__content {
    line-height: normal;
  }
  .title,
  .subTitle {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
    padding-left: 8px;
    border-left: 3px solid #3171f2;
    line-height: 16px;
    margin: 16px 0;
  }

  .el-divider {
    margin: 10px 0 16px 0;
    height: 0;
    border-top: 1px dashed #e5e5e5;
    background-color: #fff;
  }
}

.el-form {
  padding: 0;
  .el-form-item__content {
    .el-select,
    .el-date-editor,
    .el-cascader {
      width: 100%;
    }
    .el-input {
      ::v-deep > .el-input-group__prepend {
        min-width: 80px;
        .el-input__inner {
          color: #606266;
        }
      }
      ::v-deep > .el-input-group__append {
        color: #8c8c8c;
      }
    }
  }
  .el-form-item {
    margin-bottom: 16px;
    &.el-form-item--small {
      &.is-required {
        ::v-deep .el-form-item__label {
          &::before {
            content: '';
            position: relative;
            margin-right: 0;
            width: 0;
          }
          .label-title {
            display: flex;
            align-items: center;
            > span {
              display: inline-block;
              word-wrap: break-word;
              width: 100%;
              &::after {
                position: absolute;
                content: '*';
                color: #f56c6c;
                margin-right: 4px;
              }

              & + i {
                margin-left: 7px;
              }
            }
            &.hide-required-asterisk {
              > span {
                &::after {
                  content: '' !important;
                }
              }
            }
          }
        }
      }

      ::v-deep .el-form-item__content {
        .el-checkbox-group,
        .el-radio-group,
        .el-switch {
          height: 34px !important;
          line-height: 34px !important;
          display: flex;
          align-items: center;
        }
      }
    }
    ::v-deep .el-form-item__label {
      color: #626262;
    }
    ::v-deep .el-form-item__content {
      color: #262626;
    }
  }
  &.el-form--label-top {
    .el-form-item {
      ::v-deep .el-form-item__label {
        line-height: 14px;
        padding: 0 0 8px;
      }
    }
  }
  .el-col {
    .table-edit {
      ::v-deep .table-content {
        flex: 1;
        overflow: hidden;
        min-height: 250px;
        display: flex;
        flex-direction: column;
        .el-table {
          flex: 1;
          thead {
            th {
              padding: 4px 0;
            }
          }
          tbody {
            tr {
              td {
                padding: 0;
                .cell {
                  padding: 3px 5px;
                }
                .el-form-item {
                  margin-bottom: 0px;

                  .el-form-item__error {
                    position: relative !important;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.form-detail {
  .el-form--label-top {
    .el-form-item {
      margin-bottom: 10px;
    }
  }
  .el-form--label-right {
    .el-form-item {
      margin-bottom: 16px;
      ::v-deep .el-form-item__label {
        line-height: 14px;
      }
      ::v-deep .el-form-item__content {
        line-height: 14px;
        .content-area {
          margin-left: 8px;
        }
      }
    }
  }

  ::v-deep .el-form-item__label {
    padding: 0;
    .label-title {
      > span {
        &::after {
          content: '' !important;
        }
      }
    }
  }
  ::v-deep .el-form--label-left {
    .el-form-item {
      margin-bottom: 0px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .el-form-item__label {
        width: max-content !important;
        .label-title {
          > span {
            width: max-content;
          }
        }
      }
    }
    .el-form-item__content {
      line-height: 32px !important;
      margin-left: 8px !important;
    }
  }
}
::v-deep .el-autocomplete {
  width: 100%;
}
</style>
